export const RENTSPREE_PRE_LOGIN = 'pre-login'

const PARTNER_NAMES = {
  'pre-login': RENTSPREE_PRE_LOGIN,
  apartmentlist: "apartmentlist",
}

export default PARTNER_NAMES
